'use client';
import React from 'react';

function NativeScrollArea({ children }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
}

export { NativeScrollArea };
//# sourceMappingURL=NativeScrollArea.mjs.map
